var React = require('react');

function ArrowSortedUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.2 13.3L12 7l-6.2 6.3c-.2.2-.3.5-.3.7s.1.5.3.7c.2.2.4.3.7.3h11c.3 0 .5-.1.7-.3c.2-.2.3-.5.3-.7s-.1-.5-.3-.7z","fill":"#626262"}));
}

ArrowSortedUp.defaultProps = {"aria-hidden":"true","focusable":"false","width":"1em","height":"1em","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 24 24"};

module.exports = ArrowSortedUp;

ArrowSortedUp.default = ArrowSortedUp;
